{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Konuşma sınırını aştınız. Hacker planı yalnızca 500 konuşmaya izin verir.",
      "INBOXES": "Gelen kutusu sınırını aştınız. Hacker planı yalnızca web sitesi canlı sohbetini destekler. E-posta, WhatsApp gibi ek gelen kutuları ücretli bir plan gerektirir.",
      "AGENTS": "Temsilci sınırını aştınız. Hacker planı yalnızca 2 temsilciye izin verir.",
      "NON_ADMIN": "Planı yükseltmek ve tüm özellikleri kullanmaya devam etmek için lütfen yöneticinizle iletişime geçin."
    },
    "TITLE": "Hesap Ayarları",
    "SUBMIT": "Ayarları Güncelle",
    "BACK": "Geri",
    "DISMISS": "Kapat",
    "UPDATE": {
      "ERROR": "Ayarlar güncellenemedi, lütfen tekrar deneyin!",
      "SUCCESS": "Hesap ayarları başarıyla güncellendi"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Hesabınızı Sil",
      "NOTE": "Hesabınızı sildiğinizde tüm verileriniz silinir.",
      "BUTTON_TEXT": "Hesabınızı Sil",
      "CONFIRM": {
        "TITLE": "Hesabı Sil",
        "MESSAGE": "Hesabınızı silmek geri alınamaz. Kalıcı olarak silmek istediğinizi onaylamak için aşağıya hesap adınızı girin.",
        "BUTTON_TEXT": "Sil",
        "DISMISS": "İptal Et",
        "PLACE_HOLDER": "Onaylamak için {accountName} yazın"
      },
      "SUCCESS": "Hesap silinmek üzere işaretlendi",
      "FAILURE": "Hesap silinemedi, lütfen tekrar deneyin!",
      "SCHEDULED_DELETION": {
        "MESSAGE_MANUAL": "Bu hesap {deletionDate} tarihinde silinmek üzere planlandı. Bu, bir yönetici tarafından talep edildi. Bu tarihten önce silme işlemini iptal edebilirsiniz.",
        "MESSAGE_INACTIVITY": "Bu hesap, hareketsizlik nedeniyle {deletionDate} tarihinde silinmek üzere planlandı. Bu tarihten önce silme işlemini iptal edebilirsiniz.",
        "CLEAR_BUTTON": "Planlanan Silmeyi İptal Et"
      }
    },
    "FORM": {
      "ERROR": "Lütfen formdaki hataları düzeltin",
      "GENERAL_SECTION": {
        "TITLE": "Genel Ayarlar",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "Hesap Kimliği",
        "NOTE": "API tabanlı bir entegrasyon oluşturuyorsanız bu kimlik gereklidir"
      },
      "NAME": {
        "LABEL": "Hesap Adı",
        "PLACEHOLDER": "Hesap adınız",
        "ERROR": "Lütfen geçerli bir hesap adı girin"
      },
      "LANGUAGE": {
        "LABEL": "Site Dili",
        "PLACEHOLDER": "Site diliniz",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Gelen E-posta Alanı",
        "PLACEHOLDER": "E-postaları alacağınız alan",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Destek E-postası",
        "PLACEHOLDER": "Şirketinizin destek e-postası",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Etkinlik yoksa, bir biletin otomatik olarak çözülmesi gereken gün sayısı",
        "NOTE": "Herhangi bir açık konuşmanın otomatik olarak çözülmesi için gereken hareketsizlik süresi (saat).",
        "PLACEHOLDER": "30",
        "ERROR": "Lütfen geçerli bir otomatik çözüm süresi girin (minimum 1 gün ve maksimum 999 gün)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Etkinlik yoksa, boş bir konuşmanın otomatik olarak çözülmesi gereken gün sayısı",
        "PLACEHOLDER": "asla",
        "ERROR": "Lütfen geçerli bir otomatik çözüm süresi girin (minimum 1 gün ve maksimum 999 gün)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Hesabınız için e-posta ile iletişim devre dışı bırakıldı.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Artık özel alan adınızda e-postalar alabilirsiniz."
      },
      "PHONE": {
        "TITLE": "PBX Ayarları",
        "NOTE": "Telefon çağrıları için PBX bağlantınızı yapılandırın",
        "SIP_HOST": {
          "LABEL": "SIP Alan Adı"
        },
        "DIALING_MODE": {
          "LABEL": "Arama modu",
          "MODES": {
            "direct": "Doğrudan - telefon bağlantısına tıklandığında çağrı hemen aranır",
            "indirect": "Dolaylı - telefon numarası, telefon widget'ının giriş kutusunda hazırlanır"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Çağrı kaydına erişim",
          "MODES": {
            "admin_only": "Yalnızca yöneticiler",
            "admin_and_assigned_agent": "Yöneticiler ve atanan temsilci",
            "inbox_members": "Gelen kutusuna erişimi olan tüm temsilciler"
          }
        }
      },
      "EMAIL": {
        "TITLE": "E-posta Ayarları",
        "NOTE": "E-posta gelen kutularının davranışını değiştirir"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Konuşma zaman damgası görüntüleme modu",
        "MODES": {
          "both": "Oluşturulma ve son etkinlik",
          "last_activity_only": "Yalnızca son etkinlik",
          "last_customer_message": "Son müşteri mesajı"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Düşük itibarlı alan adlarını engelle"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "E-postaya verilen yanıtta orijinal mesajı dahil et"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Yeni bir konuşmayı otomatik olarak çöz"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Yeni bir e-posta konuşmasını, kişinin siparişlerini işleyen robotun gelen kutusuna otomatik olarak taşı"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Genişletilmiş etiketler - Daha büyük bir açılır pencere arayüzüyle daha uzun etiket adlarına izin ver"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - Konuşmayı son yanıtı oluşturan temsilciye otomatik olarak ata"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Anlık bildirim modu",
        "MODES": {
          "all_inboxes": "Tüm gelen kutuları - Tüm kanal türleri için bildirim gönder",
          "chat_only": "Yalnızca sohbet - Yalnızca e-posta olmayan kanallar için bildirim gönder"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Gönderilen mesajlarda imzayı açıp kapatmaya izin ver"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Temsilcinin sohbet durumunu Wallboard'da göster"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Ek dosya adlarını kısaltmadan tam olarak göster"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Şifre ile giriş",
        "MODES": {
          "allowed_for_all": "Tüm kullanıcılar için izin verildi",
          "allowed_for_agents_only": "Yalnızca temsilciler için izin verildi (yöneticiler OAuth kullanmalıdır)",
          "password_login_disabled": "Devre dışı - Yalnızca OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "Yeni bir sürüm mevcut. En son güncellemeleri almak için yeniden yükleyin.",
    "RELOAD_NOW": "Şimdi güncelle",
    "LEARN_MORE": "Daha Fazla",
    "PAYMENT_PENDING": "Ödemeniz bekliyor. Devam etmek için ödeme bilgilerinizi güncelleyin.",
    "LIMITS_UPGRADE": "Hesabınız kullanım sınırlarını aştı, lütfen İletişim Merkezi'ni kullanmaya devam etmek için planınızı yükseltin",
    "OPEN_BILLING": "Fatura Detayları"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Seçmek için enter tuşuna basın",
      "ENTER_TO_REMOVE": "Kaldırmak için enter tuşuna basın",
      "NO_OPTIONS": "Liste boş",
      "NO_RESULT": "Sonuç bulunamadı",
      "SELECT_ONE": "Birini seç",
      "SELECT": "Seç"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Bildirimler",
    "MARK_ALL_DONE": "Hepsini Tamamlandı İşaretle",
    "DELETE_TITLE": "silindi",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Okunmamış Bildirimler",
      "ALL_NOTIFICATIONS": "Tüm bildirimleri görüntüle",
      "LOADING_UNREAD_MESSAGE": "Okunmamış bildirimler yükleniyor...",
      "EMPTY_MESSAGE": "Okunmamış bildiriminiz yok"
    },
    "LIST": {
      "LOADING_MESSAGE": "Bildirimler yükleniyor...",
      "404": "Bildirim yok",
      "TABLE_HEADER": [
        "İsim",
        "Telefon Numarası",
        "Konuşmalar",
        "Son Görüşülen"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Yeni Görüşme",
      "conversation_assignment": "Atanan Görüşme",
      "assigned_conversation_new_message": "Yeni Mesaj",
      "participating_conversation_new_message": "Yeni Mesaj",
      "conversation_mention": "Bahset",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Çevrimdışı",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Yenile"
    },
    "CONNECTION_LOST": {
      "TITLE": "Bağlantı koptu",
      "DESCRIPTION": "Sunucuya ulaşamadık. Bağlantınızı kontrol edip tekrar deneyin.",
      "RETRY": "Tekrar dene"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Ara veya atla",
    "SECTIONS": {
      "GENERAL": "Genel",
      "REPORTS": "Raporlar",
      "CONVERSATION": "Konuşma",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Atananı Değiştir",
      "CHANGE_PRIORITY": "Önceliği Değiştir",
      "CHANGE_TEAM": "Takım Değiştir",
      "SNOOZE_CONVERSATION": "Konuşmayı Ertele",
      "EXECUTE_MACRO": "Kısayolu Çalıştır",
      "ADD_LABEL": "Konuşmaya Etiket Ekle",
      "REMOVE_LABEL": "Konuşmadan Etiketi Kaldır",
      "SETTINGS": "Ayarlar",
      "AI_ASSIST": "AI Yardımı",
      "APPEARANCE": "Görünüm",
      "SNOOZE_NOTIFICATION": "Sessiz bildirim"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Konuşma Paneline Git",
      "GO_TO_CONTACTS_DASHBOARD": "Kişiler Paneline Git",
      "GO_TO_REPORTS_OVERVIEW": "Raporlara Genel Bakış'a Git",
      "GO_TO_CONVERSATION_REPORTS": "Konuşma Raporlarına Git",
      "GO_TO_AGENT_REPORTS": "Temsilci Raporlarına Git",
      "GO_TO_LABEL_REPORTS": "Etiket Raporlarına Git",
      "GO_TO_INBOX_REPORTS": "Gelen Kutusu Raporlarına Git",
      "GO_TO_TEAM_REPORTS": "Ekip Raporlarına Git",
      "GO_TO_SETTINGS_AGENTS": "Temsilci Ayarlarına Git",
      "GO_TO_SETTINGS_TEAMS": "Takım Ayarlarına Git",
      "GO_TO_SETTINGS_INBOXES": "Gelen Kutusu Ayarlarına Git",
      "GO_TO_SETTINGS_LABELS": "Etiket Ayarlarına Git",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Hazır Yanıt Ayarlarına Git",
      "GO_TO_SETTINGS_APPLICATIONS": "Uygulama Ayarlarına Git",
      "GO_TO_SETTINGS_ACCOUNT": "Hesap Ayarlarına Git",
      "GO_TO_SETTINGS_PROFILE": "Profil Ayarlarına Git",
      "GO_TO_NOTIFICATIONS": "Bildirimlere Git",
      "ADD_LABELS_TO_CONVERSATION": "Konuşmaya Etiket Ekle",
      "ASSIGN_AN_AGENT": "Bir Temsilci Ata",
      "AI_ASSIST": "AI Yardımı",
      "ASSIGN_PRIORITY": "Öncelik Ata",
      "ASSIGN_A_TEAM": "Bir Takım Ata",
      "EXECUTE_A_MACRO": "Bir Kısayol Çalıştır",
      "MUTE_CONVERSATION": "Konuşmayı Sessize Al",
      "UNMUTE_CONVERSATION": "Konuşmanın Sessizliğini Kaldır",
      "REMOVE_LABEL_FROM_CONVERSATION": "Konuşmadan Etiketi Kaldır",
      "REOPEN_CONVERSATION": "Görüşmeyi Yeniden Aç",
      "RESOLVE_CONVERSATION": "Görüşmeyi Çöz",
      "SEND_TRANSCRIPT": "E-posta Transkripti Gönder",
      "SNOOZE_CONVERSATION": "Konuşmayı Ertele",
      "UNTIL_NEXT_REPLY": "Bir sonraki yanıt'a kadar",
      "UNTIL_NEXT_WEEK": "Bir sonraki haftaya kadar",
      "UNTIL_TOMORROW": "Yarına kadar",
      "UNTIL_NEXT_MONTH": "Bir sonraki aya kadar",
      "AN_HOUR_FROM_NOW": "Bir saat sonra kadar",
      "UNTIL_CUSTOM_TIME": "Özel...",
      "CHANGE_APPEARANCE": "Görünümü Değiştir",
      "LIGHT_MODE": "Açık Mod",
      "DARK_MODE": "Koyu Mod",
      "SYSTEM_MODE": "Sistem Modu",
      "SNOOZE_NOTIFICATION": "Sessiz bildirim"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Panel Uygulaması Yükleniyor..."
  },
  "COMMON": {
    "OR": "Veya",
    "CLICK_HERE": "buraya Tıkla"
  }
}
